import React from 'react';
import { BrainIcon, CoinsIcon, CompassIcon, HeartIcon, HouseIcon, SignpostIcon } from 'lucide-react';
const areas = [{
  icon: CoinsIcon,
  label: 'Dinero'
}, {
  icon: HeartIcon,
  label: 'Relaciones'
}, {
  icon: HouseIcon,
  label: 'Familia'
}, {
  icon: SignpostIcon,
  label: 'Decisiones difíciles'
}, {
  icon: BrainIcon,
  label: 'Ansiedad'
}, {
  icon: CompassIcon,
  label: 'Propósito'
}];
export function Problem() {
  return <section className="w-full bg-canvas py-16 md:py-24" data-id="element-130" data-mp="21olf9fbuf3wr">
      <div className="mx-auto w-full max-w-narrow px-5 text-center md:px-8" data-id="element-131" data-mp="26gwesh2o8nos">
        <h2 className="mx-auto max-w-2xl font-display text-[2rem] font-extrabold leading-[1.12] tracking-tight text-ink md:text-5xl" data-id="element-132" data-mp="1sphvsa8rkmhq">
          La vida no avisa cuándo va a llegar una decisión importante.
        </h2>

        <ul className="mx-auto mt-10 flex max-w-2xl flex-wrap items-center justify-center gap-3" data-id="element-133" data-mp="1iqsbybxb4ryu">
          {areas.map(area => <li key={area.label} className="inline-flex items-center gap-2.5 rounded-full border border-gray-200 bg-white px-5 py-3 font-sans text-sm font-bold text-ink" data-id="element-134" data-mp="1npltqgjmn54t">
              <area.icon className="h-4 w-4 shrink-0 text-forest-600" aria-hidden="true" data-id="element-135" data-mp="ocyb4vp9wf8c" />
              {area.label}
            </li>)}
        </ul>

        <p className="mx-auto mt-10 max-w-2xl text-lg leading-relaxed text-gray-500 md:text-xl" data-id="element-136" data-mp="xcle3lxnht3i">
          Cuando la presión aumenta, es fácil reaccionar con apuro, emoción o con la opinión de
          otros. En esos momentos no necesitás acumular más información. Necesitás{' '}
          <span className="font-bold text-ink" data-id="element-137" data-mp="jcamggoioaha">un principio claro</span> que te ayude a ordenar tus
          pensamientos, evaluar el camino y reflexionar antes de actuar.
        </p>
      </div>
    </section>;
}